import React from 'react';
import { ProjectOutlined, TableOutlined } from '@ant-design/icons';
import { WorkspaceViewEntityType, WorkspaceViewGroup, WorkspaceViewRepresentation } from '../../../types/WorkspaceView';
import CustomTooltip from '../../UI/Tooltip/CustomTooltip';
import { useViewContext } from '../../../pages/Space/Context/ViewContext';

interface ViewRepresentationCardProps {
  representation: WorkspaceViewRepresentation;
  setRepresentation: () => void;
  selected: boolean;
  viewGroup?: WorkspaceViewGroup;
  entityType?: WorkspaceViewEntityType;
}

const ViewRepresentationCard: React.FC<ViewRepresentationCardProps> = ({
  representation,
  setRepresentation,
  selected,
  viewGroup,
  entityType,
}) => {
  const resolvedGroup =
    viewGroup ??
    (location.pathname.includes(WorkspaceViewGroup.archive)
      ? WorkspaceViewGroup.archive
      : location.pathname.includes(WorkspaceViewGroup.triage)
        ? WorkspaceViewGroup.triage
        : location.pathname.includes(WorkspaceViewGroup.planning)
          ? WorkspaceViewGroup.planning
          : undefined);
  const disabled =
    representation === WorkspaceViewRepresentation.kanban &&
    (entityType === WorkspaceViewEntityType.epic ||
      resolvedGroup === WorkspaceViewGroup.planning ||
      resolvedGroup === WorkspaceViewGroup.archive ||
      resolvedGroup === WorkspaceViewGroup.triage);

  return (
    <CustomTooltip
      title={
        disabled
          ? entityType === WorkspaceViewEntityType.epic
            ? 'Kanban layout not available for Epics.'
            : resolvedGroup === WorkspaceViewGroup.archive
              ? 'Kanban layout not available for Archive.'
              : resolvedGroup === WorkspaceViewGroup.triage
                ? 'Kanban layout not available for Triage.'
                : 'Kanban layout not available for Planning.'
          : ''
      }
    >
      <div
        className={`h-full flex flex-col flex-1 items-center justify-center gap-2 rounded ${
          selected ? 'bg-brand-white' : 'bg-neutral-300'
        } ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
        onClick={() => {
          if (!disabled) {
            setRepresentation();
          }
        }}
      >
        {representation === WorkspaceViewRepresentation.table && <TableOutlined className="text-neutral-900" />}
        {representation === WorkspaceViewRepresentation.kanban && <ProjectOutlined className="text-neutral-900" />}

        <div className="text-center text-neutral-900 text-sm font-medium leading-tight">
          {representation === WorkspaceViewRepresentation.table ? 'Table View' : 'Board View'}
        </div>
      </div>
    </CustomTooltip>
  );
};

export default ViewRepresentationCard;
